import { useState } from "react"

export const ServiceState = () => {
	const [seeMoreId, setSeeMoreId] = useState([])
	const [paymentModal, setPaymentModal] = useState(false);
	const [form, setForm] = useState({
		name: { value: '', stat: false, msg: 'Enter a proper name' },
		contact_no: { value: '', stat: false, msg: 'Enter a valid contact number' },
		email: { value: '', stat: false, msg: 'Enter a proper email' },
		paymentMethod: 'GCSH',
		training_id: 0,
		training_amount: 0,
		fee_type: 1,
		trainee_type: {value: '', details: '', stat: false, msg: ''},
		type_of_training: { value: '', stat: false, msg: '' },
		prc_no: { value: '', stat: false, msg: '' },
		valid_until: { value: '', stat: false, msg: '' },
		prc_attachment: { value: '', object: '', name: '', type: '', size: '', stat: false, msg: '' },
		question_advance: '',
		with_voucher: false,
		voucher_code: { value: '' , stat: false, msg: ''}
	})
	const dfltForm = {
		name: { value: '', stat: false, msg: 'Enter a proper name' },
		contact_no: { value: '', stat: false, msg: 'Enter a valid contact number' },
		email: { value: '', stat: false, msg: 'Enter a proper email' },
		paymentMethod: 'GCSH',
		training_id: 0,
		training_amount: 0,
		fee_type: 1,
		trainee_type: {value: '', details: '', stat: false, msg: ''},
		type_of_training: { value: '', stat: false, msg: '' },
		prc_no: { value: '', stat: false, msg: '' },
		valid_until: { value: '', stat: false, msg: '' },
		prc_attachment: { value: '', object: '', name: '', type: '', size: '', stat: false, msg: '' },
		question_advance: '',
		with_voucher: false,
		voucher_code: { value: '' , stat: false, msg: ''}
	}
	const [allTrngList, setAllTrngList] = useState([]);
	const [loader, setLoader] = useState(false);
	const [upCmngTrngs, setUpCmngTrngs] = useState([]);
	const [trngAttnd, setTrngAttnd] = useState([]);
	const [sbmtLoader, setSbmtLoader] = useState(false);
	const [rcptId, setRcptId] = useState(0);
	const [receipt, setReceipt] = useState([]);
	const [inftScroll, setInftScroll] = useState(true);
	const [inftLoader, setInftLoader] = useState(true);
	const [lastId, setLastId] = useState();
	const [infoLoader, setInfoLoader] = useState(true);
	const [trngDltd, setTrngDltd] = useState(false)
	const [modal, setModal] = useState(false)
	const [viewTrng, setViewTrng] = useState({});
	const [trainingInfo, setTrainingInfo] = useState(null)

	return {
		seeMoreId: { data: seeMoreId, set: setSeeMoreId },
		paymentModal: { data: paymentModal, set: setPaymentModal },
		form: { data: form, set: setForm },
		dfltForm: { data: dfltForm },
		allTrngList: { data: allTrngList, set: setAllTrngList },
		loader: { data: loader, set: setLoader },
		upCmngTrngs: { data: upCmngTrngs, set: setUpCmngTrngs },
		trngAttnd: { data: trngAttnd, set: setTrngAttnd },
		sbmtLoader: { data: sbmtLoader, set: setSbmtLoader },
		receipt: { data: receipt, set: setReceipt },
		rcptId: { data: rcptId, set: setRcptId },
		inftScroll: { data: inftScroll, set: setInftScroll },
		inftLoader: { data: inftLoader, set: setInftLoader },
		lastId: { data: lastId, set: setLastId },
		infoLoader: { data: infoLoader, set: setInfoLoader },
		trngDltd: { data: trngDltd, set: setTrngDltd },
		modal: { data: modal, set: setModal },
		viewTrng: { data: viewTrng, set: setViewTrng },
		trainingInfo: { data: trainingInfo, set: setTrainingInfo}
	}
}
